<template>
  <div class='banner_1'>
    <div class='swiper_content'>
      <!--        <div class="swiper-container">-->
      <swiper :options='swiperOptions1'>
        <swiper-slide v-for='(item,index) in logoList' :key='index'>
          <a :href='item.link_url'><img :src='item.img'/></a>
        </swiper-slide>
        <!-- 如果需要分页器 slot插槽 会自动往里面渲染分页器-->
        <!--                      <div class="swiper-pagination" slot="pagination"></div>-->
        <!-- 如果需要导航按钮 -->
        <!--          <div class='swiper-button-prev prev1' slot='button-prev'></div>-->
        <!--          <div class='swiper-button-next next1' slot='button-next'></div>-->
      </swiper>
      <!--      </div>-->
    </div>
  </div>
</template>

<script>
  import { Logo } from '@/api/banner'
  export default {
    name: 'homeBanner',
    props: {
      type: {
        type: Number,
        default: 1
      }
    },
    data(){
      return{
        logoList:[],
        swiperOptions1: {
          // 自动播放
          autoplay: {
            delay: 3000,
          },
          // 环路播放
          loop: true,
          // 切换效果
          effect: 'slide',
          cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 100,
            shadowScale: 0.6
          },
          // 前进后退按钮
          navigation: {
            nextEl: '.swiper-button-next.next1',
            prevEl: '.swiper-button-prev.prev1',
          }
        },
      }
    },
    mounted() {
      this.get_Logo()
    },
    methods:{
      get_Logo: function() {
        Logo({type: this.type}).then(resp => {
          if (resp.status == 200) {
            this.$set(this, 'logoList', resp.data)
          }
        }).catch(error => {

        })
      },
    }
  }
</script>

<style lang='scss' scoped>
  .banner_1 {
    width: 100%;
    height: 800px;

    .swiper_content {
      width: 100%;
      height: 800px;

      .swiper-container {
        width: 100%;
        height: 800px;

        .swiper-wrapper {
          width: 100%;
          height: 800px;

          .swiper-slide {
            width: 100%;
            height: 800px;

            img {
              width: 100%;
              height: 800px;
            }
          }
        }

      }
    }
  }
</style>
